import hr from './hr.js';
import en from './en.js';

export default class Languages {
    static translations = {
        hr: hr.translations,
        en: en.translations
    };
}
